import formatDate from '~/helpers/formatDate';
import useTranslation from '~/hooks/useTranslation';
import reservationHeaderStyles from '~/styles/myEnvironment/reservation-header.module.css';
import cnh from '~/helpers/cnh';
import IconCalendar from '~icons/tabler/calendar';
import IconUsers from '~icons/tabler/users';
import IconUser from '~icons/tabler/user';
import Guibo from '../Icons/Guibo';

type Props = {
  className?: string;
  id: number | string;
  name: string;
  startDate?: string | null;
  endDate?: string | null;
  pax: number;
  guiboReleaseUrl?: string | null;
};

export default function ReservationHeader({
  className,
  id,
  name,
  startDate,
  endDate,
  pax,
  guiboReleaseUrl,
}: Props) {
  const translate = useTranslation();

  return (
    <div className={cnh(className, reservationHeaderStyles.header)}>
      <div className={reservationHeaderStyles.content}>
        <h1 className={reservationHeaderStyles.title}>
          {`${id} - `}
          {name}
        </h1>

        <div className={reservationHeaderStyles.meta}>
          {startDate && endDate && (
            <time
              className={reservationHeaderStyles.date}
              dateTime={startDate}
            >
              <IconCalendar />
              {formatDate(startDate)}
              {' – '}
              {formatDate(endDate)}
            </time>
          )}

          <div className={reservationHeaderStyles.pax}>
            {
              pax > 1
                ? <IconUsers />
                : <IconUser />
            }
            {
              pax > 1
                ? `${pax} ${translate('myEnvironment.reservations.persons')}`
                : `${pax} ${translate('myEnvironment.reservations.person')}`
            }
          </div>
        </div>
      </div>

      {guiboReleaseUrl && (
        <div className={reservationHeaderStyles.actions}>
          <a
            href={guiboReleaseUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={cnh(reservationHeaderStyles.btn, reservationHeaderStyles.btnGuibo)}
          >
            <div className={reservationHeaderStyles.btnGuiboIcon}>
              <Guibo />
            </div>
            {translate('myEnvironment.reservation.open_in_guibo')}
          </a>
        </div>
      )}
    </div>
  );
}
